export const OPERATORS = {
	EQUAL: '=',
	NOT_EQUAL: '!=',
	LIKE: '%',
	GREATER_THAN: '>',
	GREATER_THAN_EQUAL: '>=',
	LESS_THAN: '<',
	LESS_THAN_EQUAL: '<=',
	BETWEEN: 'between',
};

export const OPERATOR_OPTIONS = {
	NUMBER: [
		OPERATORS.EQUAL,
		// OPERATORS.NOT_EQUAL,
		// OPERATORS.GREATER_THAN,
		OPERATORS.GREATER_THAN_EQUAL,
		// OPERATORS.LESS_THAN,
		OPERATORS.LESS_THAN_EQUAL,
		OPERATORS.BETWEEN,
	],
	STRING: [OPERATORS.LIKE, OPERATORS.EQUAL, OPERATORS.NOT_EQUAL],
	DATE: [OPERATORS.BETWEEN],
	VOLUME: [
		OPERATORS.EQUAL,
		OPERATORS.GREATER_THAN_EQUAL,
		OPERATORS.LESS_THAN_EQUAL,
		OPERATORS.BETWEEN,
	],
	LOCATION: [OPERATORS.EQUAL, OPERATORS.NOT_EQUAL],
	STAGE: [OPERATORS.EQUAL, OPERATORS.NOT_EQUAL],
	ARCHIVED: [OPERATORS.EQUAL, OPERATORS.NOT_EQUAL],
	JOB_STATUS: [OPERATORS.EQUAL, OPERATORS.NOT_EQUAL],
	TRAILER_TYPE: [OPERATORS.EQUAL, OPERATORS.NOT_EQUAL],
	PROJECT_TYPE: [OPERATORS.EQUAL, OPERATORS.NOT_EQUAL],
};

export const LOAD_VOLUME_DURATION = ['Day', 'Week', 'Month', 'Year'];

export const INPUT_TYPES = {
	CUSTOMER: 'customer',
	DATE: 'date',
	LOCATION: 'location',
	NUMBER: 'number',
	STRING: 'string',
	TRAILER_TYPE: 'trailerType',
	USERS_LIST: 'usersList',
	VOLUME: 'volume',
	BOOLEAN: 'boolean',
	STATE: 'statesList',
	STAGE: 'stage',
	JOB_STATUS: 'jobStatus',
	IMPORT_STATS_JOB_STATUS: 'importStatsJobStatus',
	PROJECT_TYPE: 'projectType',
};

export const LOCATION_OPERATORS_LABEL = {
	[OPERATORS.EQUAL]: 'is',
	[OPERATORS.NOT_EQUAL]: 'is not',
};

export const STAGE_OPERATORS_LABEL = {
	[OPERATORS.EQUAL]: 'is',
	[OPERATORS.NOT_EQUAL]: 'is not',
};

export const ARCHIVED_OPERATORS_LABEL = {
	[OPERATORS.EQUAL]: 'is',
	[OPERATORS.NOT_EQUAL]: 'is not',
};

export const JOB_STATUS_OPERATORS_LABEL = {
	[OPERATORS.EQUAL]: 'is',
	[OPERATORS.NOT_EQUAL]: 'is not',
};

export const EQUAL_NOT_EQUAL_TYPES_LABEL = {
	[OPERATORS.EQUAL]: 'is',
	[OPERATORS.NOT_EQUAL]: 'is not',
};
